import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type HistoryTabKeys = "Online" | "Flywire" | "Offline" | "Travel Card" | "Convera";

export interface HistoryListRequestPayload {
  page: number;
  size: number;
  ascending: boolean;
  filter: string;
  fromDate: string;
  toDate: string;
  selectedTab: HistoryTabKeys;
}

interface HistoryDetailRequestPayload {
  transactionId: string;
  selectedTab: HistoryTabKeys;
  transactions: any[];
  forceRefresh?: boolean;
}

interface HistoryState {
  list: {
    data: any[];
    loading: boolean;
    error: string;
    pageMeta: {
      size: number;
      totalElements: number;
      totalPages: number;
    };
  };
  detail: {
    data: any;
    loading: boolean;
    error: string;
    currentTransactionId: string;
  };
}

const initialState: HistoryState = {
  list: {
    data: [],
    loading: false,
    error: "",
    pageMeta: {
      size: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  detail: {
    data: {},
    loading: false,
    error: "",
    currentTransactionId: "",
  },
};

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    fetchHistoryListRequested(state, _action: PayloadAction<HistoryListRequestPayload>) {
      state.list.loading = true;
      state.list.error = "";
    },
    fetchHistoryListSucceeded(
      state,
      action: PayloadAction<{
        content: any[];
        size: number;
        totalElements: number;
        totalPages: number;
      }>
    ) {
      state.list.loading = false;
      state.list.data = action.payload.content || [];
      state.list.pageMeta = {
        size: action.payload.size ?? state.list.pageMeta.size,
        totalElements: action.payload.totalElements ?? 0,
        totalPages: action.payload.totalPages ?? 0,
      };
    },
    fetchHistoryListFailed(state, action: PayloadAction<string>) {
      state.list.loading = false;
      state.list.error = action.payload;
      state.list.data = [];
    },
    fetchHistoryDetailRequested(state, action: PayloadAction<HistoryDetailRequestPayload>) {
      state.detail.loading = true;
      state.detail.error = "";
      state.detail.currentTransactionId = action.payload.transactionId;
    },
    fetchHistoryDetailSucceeded(state, action: PayloadAction<any>) {
      state.detail.loading = false;
      state.detail.data = action.payload ?? {};
    },
    fetchHistoryDetailFailed(state, action: PayloadAction<string>) {
      state.detail.loading = false;
      state.detail.error = action.payload;
      state.detail.data = {};
    },
    clearHistoryDetail(state) {
      state.detail = initialState.detail;
    },
  },
});

export const historyActions = historySlice.actions;
export default historySlice.reducer;
